import PersonPinRounded from '@mui/icons-material/PersonPinRounded';
import { Box, CircularProgress, IconButton, SxProps, Tooltip, useTheme } from '@mui/material';
import React, { FC } from 'react';

import { getUserColorPieceStatus, tooltips } from '@components/Capture/helper';
import { CapturePiece } from '@components/Capture/types';
import path from 'lodash/fp/path';

import { CommonStyles, StyledIcon, sxMR0 } from './styles';

interface IPersonPinRoundedProps {
  capturePiece: CapturePiece | null;
  onClick?: () => void;
}

const PersonPinRoundedIcon: FC<IPersonPinRoundedProps> = ({ capturePiece, onClick }) => {
  const theme = useTheme();
  if (!capturePiece) {
    return null;
  }
  const { piece } = capturePiece;
  const isUserLoading = piece?.pieceSummary?.inProgressAutoAssign;

  const color = isUserLoading ? undefined : getUserColorPieceStatus(piece);
  const themeColor = color ? path(['palette', color, 'main'], theme) : undefined;
  const disabled = !piece;

  return (
    <Tooltip title={tooltips[isUserLoading ? 'PersonPinRoundedLoading' : 'PersonPinRounded']} arrow>
      <Box component="span">
        <IconButton
          onClick={onClick}
          disabled={disabled}
          aria-label={tooltips[isUserLoading ? 'PersonPinRoundedLoading' : 'PersonPinRounded']}
          sx={{ ...CommonStyles, ...sxMR0 } as SxProps}
        >
          <PersonPinRounded sx={StyledIcon(disabled ? 'action.disabled' : themeColor)} />
          {isUserLoading && <CircularProgress aria-label="Loading..." />}
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export { PersonPinRoundedIcon };
